<script>
    import ClickOutside from 'svelte-click-outside';
    import {defaultEvmStores, signerAddress} from 'svelte-ethers-store'
    import {addEllipses} from "../utils";
    import {metaMaskExtensionInstallationLink} from "../constants/constants";
    let userDropdown = false
    let triggerEl;
    const toggleDrop = () => {
        userDropdown = !userDropdown
    }
    const hidePanel = () => {
        userDropdown = false;
    }

</script>
<div class="connect-button-wrapper">
    <a href="javascript:void(0)" class="relative">
        {#if $signerAddress}
            <figure class="user-wrapper" id="open-user-drop" on:click={toggleDrop} bind:this={triggerEl}>
                <figcaption>
                    <span>Connected</span>
                    {addEllipses($signerAddress)}
                </figcaption>
                <img src="/images/user.svg" alt="user">
            </figure>
            <ClickOutside on:clickoutside={hidePanel} exclude={[triggerEl]}>
            <div class={`button-drop-wrapper ${userDropdown ? 'userDropdown' : ''}`}>
                <a on:click={toggleDrop} id="my-project-page" href="#/sale-listing">My Projects</a>
<!--                <a on:click={toggleDrop} href="#">Create Dutch Auction</a>-->
                <a on:click={toggleDrop} id="project-creation-page" href="#/permissionless">Start Fixed Price Raise</a>
<!--                <a href="javascript:void(0)" on:click={()=>{defaultEvmStores.disconnect(); (userDropdown = !userDropdown)}} >Disconnect Wallet</a>-->
            </div>
            </ClickOutside>
            {:else}
            <button class="simple-btn" id="connect-wallet-btn" on:click={() => {
                defaultEvmStores.setProvider().catch( () => {
                   setTimeout(
                        () =>
                          window.open(metaMaskExtensionInstallationLink, "_blank"),
                        1000
                   );
                })
            }}>
               Connect
            </button>
        {/if}
    </a>
</div>

